<template>
    <div class="component-stock" v-if="internalValue">

        <modal
                v-model="internalValue"
                v-show="isModalVisible"
                @close="closeModal"
                @validate="validateModal"/>


        <div class="form-field form-products">
            <div class="form-label">Inventaires</div>
            <div class="form-input">
                <div v-for="product in internalValue" v-if="product.inventories">
                    <div v-for="inventory in product.inventories" class="product-listing">
                        <div><i class="icon icon-icon_crate"></i></div>
                        <div>
                            <span class="name">{{ inventory.name }}</span>
                            <span class="sku">{{ inventory.internal_identifier }}</span>
                        </div>
                        <div><b style="font-weight:bold;">{{ inventory.quantity }}</b> pièce(s)</div>
                        <div>{{ inventory.available_at }}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import Modal from './StockModal.vue'

    export default {
        props: ['value'],
        components: {
            Modal
        },
        data: function () {
            return {
                internalValue: [],
                inventory: null,
                isModalVisible: false,
                tmpStock: 0,
                test: null
            }
        },
        created: function() {
            this.internalValue = this.value
        },
        methods: {
            closeModal() {
                this.isModalVisible = false;
            },
            validateModal() {
                this.closeModal()
            },
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Stock.vue